/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { monthMappingReverse } from '../../../../SharedModules/utilities/utilities';

const dateFormatter = (params) => {
  const d = params.value.split('-');
  const date = new Date(`${monthMappingReverse[d[1]]}/${d[0]}/${d[2]}`);
  if (date !== 'Invalid Date') {
    return `${monthMappingReverse[d[1]]}/${d[0]}/${d[2]}`;
  }
  return params.value;
};

export const contractMfgTableColDefs = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_200,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contractDrugFamilyTableColDefs = [
  {
    headerName: 'Drug Family ID',
    field: 'familySeqNum',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    minWidth: Styles.Width_200,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Family Name',
    field: 'familyName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contractMarketBasketTableColDefs = [
  {
    headerName: 'Market Basket ID',
    field: 'marketBasketSeqNum',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    minWidth: Styles.Width_200,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Basket Name',
    field: 'marketBasketName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contractTableColDefs = [
  {
    headerName: 'Contract ID',
    field: 'contractSeqNum',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
   dataAlignRight: true,
      excelAlignment: 'right',
      cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor }, 
    minWidth: Styles.Width_200,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contract Name',
    field: 'contractName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const drugFamilyContractTableHead = [
  {
    headerName: 'Contract ID',
    field: 'contractSeqNum',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_50,
    maxWidth: Styles.Width_120,
    
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },

    wrapText: true,
    autoHeight: true,
  },
  {
    headerName: 'Contract Name',
    field: 'contractName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },

    wrapText: true,
    autoHeight: true,
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_50,
    maxWidth: Styles.Width_150,
    cellRenderer: dateFormatter,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_50,
    maxWidth: Styles.Width_150,
    cellRenderer: dateFormatter,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'shortDescr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    maxWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const marketBasketContractTableHead = [
  {
    headerName: 'Contract ID',
    field: 'contractSeqNum',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_220,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },

    wrapText: true,
    autoHeight: true,
  },
  //   {
  //     headerName: 'Contract Name',
  //     field: 'contractName',
  //     editable: false,
  //     suppressMenu: false,
  //     sortable: true,
  //     minWidth: Styles.Width_220,
  //     cellRenderer: 'GenericCodeTextBox',
  //     cellEditorParams: {
  //       maxLength: 5,
  //       custWidth: '135px',
  //     },
  //     custClass: 'tbill-rate-editable-input',
  //     filter: 'agTextColumnFilter',
  //     filterParams: {
  //       defaultOption: 'startsWith',
  //       suppressAndOrCondition: true,
  //       buttons: ['reset'],
  //       refreshValuesOnOpen: true,
  //     },

  //     wrapText: true,
  //     autoHeight: true,
  //   },
];
